module.exports = __webpack_public_path__ + "img/address.d4bba1a.png";